import React, { Component } from 'react';
import { Header, Image, Button, Grid, } from 'semantic-ui-react'
import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export class OrderComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {


        return (<div>
            <Grid.Column style={{ maxWidth: 450 }}>
                <Image src={require('./img/printbodalogo_large.png')} />
                <Header as='h2' color='blue' textAlign='center'>
                    {' '} Order Complete!
                <Header.Subheader>
                        Thank you for placing your order.
                </Header.Subheader>

                    <Header.Subheader>
                        You can expect your item in 3-5 working days after receipt of deposit. If design is required for your item, it will be completed 2-3 working days after you approve the design and receipt of deposit.
                        </Header.Subheader>

                        {' '} Deposit Policy
                    <Header.Subheader>
                            We can't wait to begin on a one of a kind customized item just for you.
                        Once you have approved your design. We will require a 50% deposit before we can complete your order. The balance will be payable on delivery of your item.
                    </Header.Subheader>
                    
                    
                        <br />
                        <Header.Subheader>
                            You can reach us at 0757 477 399 with any questions or check out our facebook page:
                            <a href={"https://www.facebook.com/Printbodaonline"}>https://www.facebook.com/Printbodaonline</a> 
                    </Header.Subheader>

                    <Header.Subheader>

                    </Header.Subheader>
                    <Header.Subheader>
                        <br />
                        <Button massive color='green' onClick={() => history.push('/')}>
                            HOME
                    </Button>
                    </Header.Subheader>

                </Header>
                <Header as='h2' color='blue' textAlign='center'>
                    You can contact us @ 0757 477 399 (Call Or Whatsapp)
            </Header>
            </Grid.Column>
        </div>
        )
    }
}

export default OrderComplete;


// WEBPACK FOOTER //
// ./src/components/newSite/OrderComplete.js